import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Upload scheduler concurrency mode or worker count changed',
  name: 'upload_concurrency_changed',
  params: [
    {
      description: 'Upload flow where the scheduler is running',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['private_upload', 'content_collection'],
    },
    {
      description: 'Concurrency mode after the change',
      name: 'concurrency_mode',
      required: true,
      type: 'enum',
      values: ['fixed', 'adaptive'],
    },
    {
      description: 'Why concurrency changed',
      name: 'change_reason',
      required: true,
      type: 'enum',
      values: ['upload_instability_detected', 'speed_adjustment', 'reverted_to_fixed'],
    },
    {
      description: 'Scheduler worker count before the change',
      name: 'from_workers',
      required: true,
      type: 'number',
    },
    {
      description: 'Scheduler worker count after the change',
      name: 'to_workers',
      required: true,
      type: 'number',
    },
    {
      description: 'Measured upload speed in bytes per second when the change occurred',
      name: 'upload_speed_bytes_per_second',
      required: false,
      type: 'number',
    },
    {
      description: 'Bytes currently in-flight across active uploads when the change occurred',
      name: 'in_flight_bytes',
      required: false,
      type: 'number',
    },
    {
      description: 'Number of scheduler workers actively running upload tasks when the change occurred',
      name: 'active_workers',
      required: false,
      type: 'number',
    },
    {
      description:
        'Adaptive concurrency bandwidth budget in bytes (speed × budget multiplier) when the change occurred',
      name: 'concurrency_budget_bytes',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
